import { Countries } from "../resources/Countries";

export const findCountry = (countryCode) => {
  return Countries.find((c) => c.value === countryCode);
};

export const findState = (stateCode, provinces) => {
  return provinces.find((p) => p.value === stateCode);
};
